module.exports = __webpack_public_path__ + "static/media/policy-2.c99d5672.png";